"use strict";

// дефолтные значения дейтпикера
// сбытия нужны для стилизации дропдаунов
(function(){
    $.datepicker.setDefaults({
        "beforeShow": function(input, inst){
            if (inst.settings.classes){
                $(inst.dpDiv).addClass(inst.settings.classes);
            }
            if (inst.settings.zIndex){
                setTimeout(function(){
                    $(inst.dpDiv).css("z-index", inst.settings.zIndex);
                },0 );
            }
            $(input).trigger("datepicker-beforeshow", [input, inst]);
            if (inst.settings.callbackBeforeShow){
                inst.settings.callbackBeforeShow.call(this, input, inst);
            }
        },
        "onChangeMonthYear" : function(year, month, inst){
            $(this).trigger("datepicker-changemonthyear", [year, month, inst]);
            if (inst.settings.callbackChangeMonthYear){
                inst.settings.callbackChangeMonthYear.call(this, year, month, inst);
            }
        },
        "dateFormat" : "yy-mm-dd",
        "firstDay" : Fotobook.config.data[Fotobook.Settings.REGIONAL_FIRST_DAY_OF_WEEK],
    });

    // Переопределил стандартный метод датапикера _gotoToday, т.к. он не делал того фун-ла, который от него требовался
    $.datepicker._gotoToday = function(id) {
        var today = new Date(),
            dateRef = $("<td><a>" + today.getDate() + "</a></td>");
        this._selectDay(id, today.getMonth(), today.getFullYear(), dateRef);
    };

    // jQueryUI почему-то не регистрирует datepicker как виджет
    $.expr[":"]["datepicker"] = function(elem) {
        return !!$.data(elem, "datepicker");
    };
})();
